
/* User defined models */
export class Client {
  id: string;
  code: string;
  uri: string;
  name: string;
  sso: boolean;
  requiresBiometricConsent: boolean;
  // TODO: change to Location Type
  location?: any;

  constructor(
    id: string,
    code: string,
    uri: string,
    name: string,
    sso: boolean,
    requiresBiometricConsent: boolean,
    location?: any
  ) {
    this.id = id;
    this.code = code;
    this.uri = uri;
    this.name = name;
    this.sso = sso;
    this.requiresBiometricConsent = requiresBiometricConsent;
    this.location = location;
  }
}
